{
  "A - Z": "A - Z",
  "Abandoned Call": "Abandoned Call",
  "Appointment Reactivation": "Appointment Reactivation",
  "Appointment Recall": "Appointment Recall",
  "Appointment Reminder": "Appointment Reminder",
  "Attach files": "Attach files",
  "Attachments": "Attachments",
  "Auto Message": "Auto Message",
  "Auto Message Voicemail": "Auto Message Voicemail",
  "Back": "Back",
  "Cancel": "Cancel",
  "CareCredit Application": "CareCredit Application",
  "CareCredit Collect": "CareCredit Collect",
  "CareCredit Preapproved": "CareCredit Preapproved",
  "Contacts could not be searched. Please ensure you have only one organization selected, and try again.": "Contacts could not be searched. Please ensure you have only one organization selected, and try again.",
  "Create New Template": "Create New Template",
  "Default Template": "Default Template",
  "Default {{type}} Template": "Default {{type}} Template",
  "Delivery Error": "Delivery Error",
  "Deselect All": "Deselect All",
  "Drop files here ({{allowedFileTypesString}} files only).": "Drop files here ({{allowedFileTypesString}} files only).",
  "Edit template {{templateName}}": "Edit template {{templateName}}",
  "Error scheduling message. Please try again.": "Error scheduling message. Please try again.",
  "Error sending email. Please try again.": "Error sending email. Please try again.",
  "Error sending message. Please try again.": "Error sending message. Please try again.",
  "Error uploading image. Please try again.": "Error uploading image. Please try again.",
  "Error uploading. Please try again.": "Error uploading. Please try again.",
  "Form Request": "Form Request",
  "From:": "From:",
  "In Your Link": "In Your Link",
  "Inbound Call": "Inbound Call",
  "Input a valid phone number before sending": "Input a valid phone number before sending",
  "Insert": "Insert",
  "Insert & Select Message Template": "Insert & Select Message Template",
  "Invoice": "Invoice",
  "Manual": "Manual",
  "Message Templates": "Message Templates",
  "Message scheduled successfully.": "Message scheduled successfully.",
  "Message sent successfully.": "Message sent successfully.",
  "Missed Call": "Missed Call",
  "Most Recent": "Most Recent",
  "New Template": "New Template",
  "New {{type}} Template": "New {{type}} Template",
  "No text to pay link available for the selected invoice. Please select another invoice.": "No text to pay link available for the selected invoice. Please select another invoice.",
  "Not Delivered": "Not Delivered",
  "Outbound Call": "Outbound Call",
  "Payment": "Payment",
  "Please select an invoice": "Please select an invoice",
  "Please select at least one recipient.": "Please select at least one recipient.",
  "Remove image": "Remove image",
  "Review Request": "Review Request",
  "Schedule": "Schedule",
  "Select Contacts": "Select Contacts",
  "Select Recipient": "Select Recipient",
  "Select Recipients": "Select Recipients",
  "Select Template": "Select Template",
  "Select a Payments Template": "Select a Payments Template",
  "Select a Template": "Select a Template",
  "Selected {{count}} of {{maxCount}} max_one": "Selected {{count}} of {{maxCount}} max",
  "Selected {{count}} of {{maxCount}} max_other": "Selected {{count}} of {{maxCount}} max",
  "Send Now": "Send Now",
  "Sending to": "Sending to",
  "Share in Message": "Share in Message",
  "Sort by": "Sort by",
  "Subject Line": "Subject Line",
  "Subject:": "Subject:",
  "Template search": "Template search",
  "This link can't be sent": "This link can't be sent",
  "This message was deleted on {{date}} by {{name}}": "This message was deleted on {{date}} by {{name}}",
  "To:": "To:",
  "Unknown Call": "Unknown Call",
  "Unknown User": "Unknown User",
  "View More": "View More",
  "Voicemail": "Voicemail",
  "Waitlist": "Waitlist",
  "Weave": "Weave",
  "You can only send up to 10 files in a single message. {{count}} files were not uploaded._one": "You can only send up to 10 files in a single message. {{count}} files were not uploaded.",
  "You can only send up to 10 files in a single message. {{count}} files were not uploaded._other": "You can only send up to 10 files in a single message. {{count}} files were not uploaded.",
  "You can only send up to 10 images in a single message. {{count}} images were not uploaded._one": "You can only send up to 10 images in a single message. {{count}} images were not uploaded.",
  "You can only send up to 10 images in a single message. {{count}} images were not uploaded._other": "You can only send up to 10 images in a single message. {{count}} images were not uploaded.",
  "You do not have permission to send messages.": "You do not have permission to send messages.",
  "You do not have permission to view or send text messages": "You do not have permission to view or send text messages",
  "You have reached the end": "You have reached the end",
  "Z - A": "Z - A",
  "{{count}} Contact_one": "{{count}} Contact",
  "{{count}} Contact_other": "{{count}} Contacts",
  "{{personName}}'s Outstanding Requests": "{{personName}}'s Outstanding Requests"
}
